export default function Aurora({ opacity }) {
  return (
    <div className={'app-aurora'} style={{opacity: opacity}}>

    </div>
  )
}
